import './Sections.scss';

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { useConfig } from '@/common/contexts/ConfigContext';
import { useSectionsContext } from '@/common/contexts/SectionContext/SectionContext';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';

import CategoryBanner from '../../blocks/OffersCategory/CategoryBanner/CategoryBanner';
import SectionsContent from '../../blocks/Sections/Content/SectionsContent';

const Sections = () => {
  const { t } = useTranslation();
  const { env } = useConfig();

  const { allDepths, data, isSuccess, isLoading } = useSectionsContext();

  if (isLoading && !isSuccess) {
    return <PageLoader className="page-sections" />;
  }

  if (isSuccess) {
    return (
      <>
        <Helmet>
          <title>
            {`${data.parents[data.parents.length - 1].name} - ${t(
              `${env}:messages:title`,
            )}`}
          </title>
        </Helmet>
        <main className="main page-sections">
          <CategoryBanner
            categoryName={data.parents[data.parents.length - 1].name}
            upperCategory={data.parents[data.parents.length - 2]?.name}
            upperCategorySlug={data.parents[data.parents.length - 2]?.slug}
            categoryFromBack
            image={
              data.parents.length <= 1
                ? data.parents[data.parents.length - 1]?.image
                : null
            }
            className="sections__category-banner"
          />
          <SectionsContent allDepths={allDepths} categories={data.children} />
        </main>
      </>
    );
  }

  return null;
};

export default Sections;
